import type { GetStaticProps, NextPage } from "next";
import { NewsPage } from "src/domains/shared/components/Home/News";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";

const News: NextPage = () => (
  <SiteLayout>
    <NewsPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default News;
